import * as types from '../mutation_types'
import L from 'leaflet'

// Initial state
const state = {
    located: false,
    latLng: null,
    latLngAccuracy: null,
    uploads: [],
    menuOpen: false,
    capturedMedia: null
};

// Getters
const getters = {
};

// Actions
const actions = {
    setClientPosition({commit}, position) {
        commit(types.SET_CLIENT_POSITION, {
            latLng: L.latLng(position.coords.latitude, position.coords.longitude),
            accuracy: position.coords.accuracy
        });
    },

    setCapturedMedia({ commit }, file) {
        commit(types.SET_CAPTURED_MEDIA, file)
    },

    upload({state, commit}, index) {
        commit(types.UPLOAD_REQUEST, index);

        // Prepare form
        const upload = state.uploads[index];
        const formData = new FormData();

        upload.fields.forEach(field => formData.append(field.key, field.value));

        //if (upload.type === 'image') {
            formData.append('Content-Type', 'image/png');
            formData.append('key', upload.prefix + '.png');
        //} else if (upload.type === 'video') {
        //    formData.append('Content-Type', 'video/mp4');
        //    formData.append('key', upload.prefix + '.mp4');
        //}

        // Add file to form data
        formData.append('file', upload.data);

        console.log('upload', upload, formData)

        // Upload file
        const post = new XMLHttpRequest();

        post.addEventListener('load', () => {
            console.log(post.responseText);
        });

        post.addEventListener('error', err => {
            console.log(err);
        });

        post.open('POST', upload.target);
        post.send(formData);
    }
};

// Mutations
const mutations = {
    [types.SET_CLIENT_POSITION] (state, {latLng, accuracy}) {
        state.located = true;
        state.latLng = latLng;
        state.latLngAccuracy = accuracy;
    },

    [types.SET_CAPTURED_MEDIA] (state, file) {
        state.capturedMedia = file
    },

    [types.SEND_ANSWER_SUCCESS] (state, response) {
        // Queue media upload if question type was photo or video
        if (response.media && state.capturedMedia) {
            state.uploads.push(Object.assign({}, response.media, {
                data: state.capturedMedia,
                type: state.capturingMediaType,
                started: false,
                progress: 0
            }));
        }

        // Clear captured media
        state.capturedMedia = null;
    },

    [types.UPLOAD_REQUEST] (state, index) {
        state.uploads[index].started = true;
    },

    OPEN_MENU(state) {
        state.menuOpen = true;
    },

    CLOSE_MENU(state) {
        state.menuOpen = false;
    },

    EXIT_GAME(state) {
        state.menuOpen = false;
    }
};

// Export
export default {
    state,
    getters,
    actions,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/client.js